import React, { FC } from 'react';
// package imports
import { ListCards } from '@/components/molecules/ListCards/render';
// internal imports
import block from './block.json';

export type ListCalendarProps = {
	title?: string;
	getStyles?: (styles: any) => string;
} & ThemeProps &
	ChildrenProps;

/**
 * COMPONENT
 */
export const ListCalendar: FC<ListCalendarProps> & BlockConfigs = (props) => {
	return <ListCards {...props} slug={block.slug} />;
};

ListCalendar.slug = block.slug;
ListCalendar.title = block.title;
